import React, { useState } from "react";
import classNames from "classnames/bind";
import Camera from "./Camera/Camera";
import User from "./User/User";
import styles from "./RoleCamera.module.css";
import { Loading, Toast } from "../../../components";
import { role } from "../../../services/api/RoleApi";

const cx = classNames.bind(styles);

const RoleCamera = () => {
  const [userCode, setUserCode] = useState();
  const [companyCode, setCompanyCode] = useState();
  const [listCamera, setListCamera] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const handleAddCameraUser = () => {
    setIsLoading(true)
    async function addUserCam() {
      try {
        const data = listCamera.map((item) => {
          return {
            camera_code: item.CODE,
            prioritized: 0,
          };
        });
        if (userCode) {
          const res = await role.addCameraUser(
            JSON.stringify({
              username: userCode,
              company_code: companyCode,
              list_camera: {
                data,
              },
            })
          );
          if (res.result) {
            setIsLoading(false)
            setIsRefresh(!isRefresh)
            Toast.open("Thêm mới camera cho người dùng thành công", "success");
          } else {
            setIsLoading(false)
          }
        } else {
          setIsLoading(false)
          Toast.open("Vui lòng chọn người dùng", "danger");
        }
      } catch (e) {
        if (e.response.status === 403) {
          setIsLoading(false)
          Toast.open("Bạn không có quyền phân camera cho người dùng", "danger");
        } else {
          setIsLoading(false)
          Toast.open(e.response.data.mess, 'danger')
        }
      }
    }
    addUserCam();
  };
  return (
    <>
      <div className={cx("header")}>
        <h1 className={cx("title")}>Phân quyền sử dụng camera</h1>
      </div>
      <div className={cx("content")}>
        <div className={cx("list-user")}>
          <User code={userCode} setUserCode={setUserCode} setCompanyCode={setCompanyCode} refresh={isRefresh} />
        </div>
        <div className={cx("list-camera")}>
          <Camera
            code={userCode}
            company={companyCode}
            setListCamera={setListCamera}
            listCamera={listCamera}
          />
        </div>
      </div>
      <div className={cx("footer")}>
        <button onClick={handleAddCameraUser} className={cx("btn-add")}>
          Áp dụng
        </button>
        <button className={cx("btn-cancel")}>Hủy bỏ</button>
      </div>
      {loading && (
        <div className={cx('loading-modal')}>
          <Loading />
        </div>
      )}
    </>
  );
};

export default RoleCamera;
